// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    COMPANY_INDEX_GROUPS_LOADING() {
      return {
        isLoading: true
      };
    },
    COMPANY_INDEX_GROUPS_LOADED() {
      return {
        isLoading: false,
        data: action.companyIndexGroups
      };
    },
    COMPANY_INDEX_GROUPS_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyIndexGroups.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
